import React from 'react'
import { Outlet } from 'react-router-dom'
import { DesignProvider } from 'context/design.js'
import { AdminLayoutProvider } from 'context/admin-layout'
import DashboardShell from './shell/dashboard-shell'

function AdminLayout() {
  return (
    <AdminLayoutProvider>
      <DesignProvider>
        <DashboardShell>
          <Outlet />
        </DashboardShell>
      </DesignProvider>
    </AdminLayoutProvider>
  )
}

export default AdminLayout
